import { render, staticRenderFns } from "./LugniumList.vue?vue&type=template&id=03a41735&scoped=true&"
import script from "./LugniumList.vue?vue&type=script&lang=js&"
export * from "./LugniumList.vue?vue&type=script&lang=js&"
import style0 from "./LugniumList.vue?vue&type=style&index=0&id=03a41735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a41735",
  null
  
)

export default component.exports